import { createContext, useContext } from "react";

const StopwatchContext = createContext({});

export const StopwatchContextProvider = StopwatchContext.Provider;
export const StopwatchContextConsumer = StopwatchContext.Consumer;

export const useStopwatchContext = () => useContext(StopwatchContext);

export default StopwatchContext;
